'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { AddressIconView } from './AddressIconView';
import { useAddressName } from '../../../stores/addressBookStore';
const AddressIcon = ({ address, size, className, network, providerName, }) => {
    const savedName = useAddressName(address, network, providerName);
    return (_jsx(AddressIconView, { address: address, size: size, className: className, saved: !!savedName }));
};
export default AddressIcon;
